import React, { useState } from "react";
import { Package, Truck, Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { api, apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

export const RoleChooser = () => {
  const { switchMode, user } = useAuth();
  const Card = ({ m, Icon, title, sub, cls }) => (
    <button data-testid={`choose-${m}`} onClick={() => switchMode(m)}
            className={`text-left rounded-3xl border-2 p-6 sm:p-8 transition-transform hover:-translate-y-0.5 ${cls}`}>
      <Icon className="w-8 h-8"/>
      <div className="font-display text-2xl font-extrabold mt-4">{title}</div>
      <div className="text-sm mt-1 opacity-80">{sub}</div>
    </button>
  );
  return (
    <div className="py-6" data-testid="role-chooser">
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold">Hi {user?.first_name || "there"}, what would you like to do?</h1>
      <p className="text-slate-500 mt-1 text-sm">You can switch any time from the header.</p>
      <div className="grid sm:grid-cols-2 gap-4 mt-6">
        <Card m="sender" Icon={Package} title="Send a parcel" sub="Find a verified traveller already going your way." cls="border-amber-300 bg-amber-50 text-amber-950"/>
        <Card m="carrier" Icon={Truck} title="Earn as a carrier" sub="Carry parcels on trips you're already making." cls="border-teal-300 bg-teal-50 text-teal-950"/>
      </div>
    </div>
  );
};

export const NamePrompt = () => {
  const { user, refresh } = useAuth();
  const [first, setFirst] = useState(user?.first_name || "");
  const [last, setLast] = useState(user?.last_name || "");
  const [busy, setBusy] = useState(false);
  if (!user?.needs_name) return null;
  const save = async () => {
    setBusy(true);
    try { await api.patch("/users/me", { first_name: first, last_name: last }); await refresh(); toast.success("Thanks!"); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <Dialog open>
      <DialogContent className="[&>button]:hidden" data-testid="name-prompt">
        <DialogHeader>
          <DialogTitle>What's your name?</DialogTitle>
          <DialogDescription>Others will see your first name and last initial, e.g. "Manveet K."</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          <Input data-testid="prompt-first-name" value={first} onChange={(e) => setFirst(e.target.value)} placeholder="First name"/>
          <Input data-testid="prompt-last-name" value={last} onChange={(e) => setLast(e.target.value)} placeholder="Last name"/>
        </div>
        <div>
          <Button data-testid="prompt-name-save" onClick={save} disabled={busy || !first.trim() || !last.trim()} className="w-full rounded-full">
            {busy ? <Loader2 className="w-4 h-4 animate-spin"/> : "Save"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
